import { Message, RiskStatus } from "@/app/store/types";
import { parseFileData } from "@/app/utils/file";
import { Image } from "@douyinfe/semi-ui";
import React from "react";
import styles from "./Image.module.scss";
import { useFileLoaded } from "@/app/hooks/useFileLoad";
import Locale from "@/app/locales";

export default function ImageComponent({ msg }: { msg: Message }) {
  const { onload } = useFileLoaded(msg);
  const content = msg.content as string;

  if (msg.riskStatus === RiskStatus.Failed) {
    return <div>{Locale.riskMsg.forbidden}</div>;
  }

  return (
    <Image
      src={parseFileData(content)?.fileUrl}
      alt={parseFileData(content)?.fileName}
      height={200}
      className={styles.image}
      onLoad={onload}
    />
  );
}
